import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

export const ar = {
  common: {
    streamItem: 'عنصر التدفق',
    description: 'الوصف',
    httpMethod: 'طريقة HTTP',
    path: 'المسار',
    copyDefault: 'نسخ القيمة الافتراضية',
    copyExample: 'نسخ القيمة النموذجية',
  },
  search: {
    label: 'بحث',
    inputLabel: 'أدخل استعلام البحث',
    open: 'فتح البحث',
    placeholder: 'بحث...',
    clear: 'مسح البحث',
    noResults: 'لم يتم العثور على نتائج',
    keyboardShortcut: 'اختصار لوحة المفاتيح:',
    command: 'مفتاح الأوامر',
    control: 'مفتاح التحكم',
    results: 'نتائج البحث في المرجع',
    navigate: 'تنقّل',
    select: 'اختيار',
    instructions: 'اضغط السهم للأعلى أو للأسفل للتنقل، Enter للاختيار، واكتب لتصفية النتائج',
    entryHeading: 'عنوان',
    entryOperation: 'عملية',
    entryTag: 'وسم',
    entryTagGroup: 'مجموعة وسوم',
    entryWebhook: 'خطاف ويب',
  },
  navigation: {
    introduction: 'المقدمة',
    closeGroup: 'إغلاق المجموعة',
    closeMenu: 'إغلاق القائمة',
    openGroup: 'فتح المجموعة',
    openMenu: 'فتح القائمة',
    operations: 'العمليات',
    endpoints: 'نقاط نهاية {name}',
    showAllEndpoints: 'إظهار كل نقاط نهاية {name}',
    sidebarFor: 'الشريط الجانبي لـ {name}',
    mainContent: 'وثائق واجهة برمجة التطبيقات لـ {name}',
    collapsed: 'مطوي',
    webhooks: 'خطافات الويب',
    channels: 'القنوات',
  },
  server: {
    label: 'الخادم',
    select: 'اختر خادماً',
  },
  info: {
    termsOfService: 'شروط الخدمة',
  },
  asyncapi: {
    servers: 'الخوادم',
    protocols: 'البروتوكولات',
  },
  clientLibraries: {
    heading: 'مكتبات العملاء',
    more: 'المزيد',
    selectAll: 'اختر من جميع العملاء',
  },
  operation: {
    codeSampleUnavailable: 'لا يوجد نموذج تعليمات برمجية متاح لهذا المثال.',
    body: 'الجسم',
    cookies: 'ملفات تعريف الارتباط',
    headers: 'الرؤوس',
    pathParameters: 'معاملات المسار',
    queryParameters: 'معاملات الاستعلام',
    requestBody: 'جسم الطلب',
    responses: 'الاستجابات',
    testRequest: 'اختبار الطلب',
    webhook: 'خطاف ويب',
    selectedContentType: 'نوع المحتوى المحدد',
    callbacks: 'عمليات الاستدعاء',
  },
  response: {
    exampleResponses: 'أمثلة الاستجابات',
    noBody: 'لا يوجد جسم',
    showSchema: 'عرض المخطط',
    status: 'الحالة',
  },
  schema: {
    noAllowedValues: 'لا توجد قيم تستوفي قيد التعداد هذا.',
    example: 'مثال',
    examples: 'أمثلة',
    default: 'الافتراضي',
    schema: 'المخطط',
    emptyObject: 'كائن فارغ',
    showAdditionalProperties: 'إظهار الخصائص الإضافية',
    forName: 'لـ {name}',
    showSchemaDetails: 'إظهار تفاصيل المخطط',
    oneOf: 'واحد من',
    anyOf: 'أي من',
    allOf: 'كل من',
    not: 'ليس',
    unknownType: 'نوع غير معروف',
    propertyCount: 'الخصائص: {count}',
    headerCount: 'الترويسات: {count}',
    recursiveReference: 'مرجع تكراري إلى {name}',
    recursive: 'تكراري',
    additionalProperties: 'خصائص إضافية',
    const: 'ثابت',
    deprecated: 'مهمل',
    discriminator: 'المميّز',
    enum: 'تعداد',
    format: 'التنسيق',
    greaterThan: 'أكبر من',
    keys: 'المفاتيح',
    lessThan: 'أقل من',
    max: 'الحد الأقصى',
    min: 'الحد الأدنى',
    maxLength: 'أقصى طول',
    minLength: 'أدنى طول',
    multipleOf: 'مضاعف لـ',
    nullable: 'يقبل null',
    propertyNames: 'أسماء الخصائص',
    pattern: 'النمط',
    copyPattern: 'نسخ النمط',
    readOnly: 'قراءة فقط',
    required: 'مطلوب',
    hideValues: 'إخفاء القيم',
    showAllValues: 'عرض كل القيم',
    type: 'النوع',
    unique: 'فريد',
    values: 'القيم',
    writeOnly: 'كتابة فقط',
  },
  download: {
    openapi: 'تنزيل مستند OpenAPI',
    asyncapi: 'تنزيل مستند AsyncAPI',
  },
  models: {
    label: 'النماذج',
  },
  actions: {
    copyAsMarkdown: 'نسخ بصيغة Markdown',
    copied: 'تم النسخ',
    copyMarkdownFailed: 'تعذر نسخ Markdown',

    copyLink: 'نسخ الرابط',
    copyLinkTo: 'نسخ الرابط إلى {name}',
    copyToClipboard: 'نسخ الرابط إلى الحافظة',
    copyEndpointUrl: 'نسخ رابط endpoint',
    showMore: 'عرض المزيد',
  },
  agent: {
    askAi: 'اسأل الذكاء الاصطناعي',
    askAiAgent: 'اسأل وكيل الذكاء الاصطناعي',
    close: 'إغلاق العميل',
  },
  mcp: {
    generate: 'إنشاء MCP',
    connect: 'ربط MCP',
  },
  developerTools: {
    title: 'أدوات المطورين',
    configure: 'الإعداد',
    share: 'مشاركة',
    deploy: 'نشر',
    scalarConfiguration: 'إعدادات Scalar',
    theme: 'السمة',
    layout: 'التخطيط',
    layoutOptions: 'خيارات التخطيط',
    intro: 'تتيح لك أدوات المطورين تخصيص مظهر الوثائق وسلوكها. يمكنك أيضًا مشاركة وثائقك باستخدام Scalar Registry.',
    disableToolbarBefore: 'لتعطيل شريط الأدوات، عيّن',
    disableToolbarAfter: 'في الإعدادات.',
    localhostOnly: 'لن تظهر أدوات المطورين إلا عند التشغيل على localhost.',
    layoutModern: 'حديث',
    layoutClassic: 'كلاسيكي',
    showSidebar: 'إظهار الشريط الجانبي',
    defaultOpenFirstTag: 'فتح أول وسم افتراضيًا',
    defaultOpenAllTags: 'فتح كل الوسوم افتراضيًا',
    expandAll: 'توسيع كل {label}',
    expandAllResponses: 'توسيع كل الاستجابات',
    hideClientButton: 'إخفاء زر العميل',
    hideDarkModeToggle: 'إخفاء مفتاح الوضع الداكن',
    hideModels: 'إخفاء {label}',
    hideSearch: 'إخفاء البحث',
    showOperationId: 'إظهار معرّف العملية',
    hideTestRequestButton: 'إخفاء زر طلب الاختبار',
    scalarDocs: 'Scalar Docs',
    deployDescription: 'انشر وثائقك على Scalar، منصة الوثائق الحديثة لواجهة API الخاصة بك وكل شيء آخر.',
    shareTitle: 'مشاركة API Reference',
    shareDescription: 'حمّل مستند OpenAPI لمشاركة API Reference مع الآخرين. الأمر بسيط كضغط زر.',
    uploadDocument: 'تحميل المستند',
    temporaryLinkExpiration: 'سيتم حذف المستند تلقائيًا بعد 7 أيام.',
    deployOnScalar: 'النشر على Scalar',
    deployFree: 'انشر وثائقك مجانًا.',
    additionalFeaturesMightRequire: 'قد تتطلب الميزات الإضافية',
    generate: 'إنشاء',
    passwordProtection: 'الحماية بكلمة مرور',
    customDomains: 'نطاقات مخصصة',
    freeFormContent: 'محتوى حر',
    cdnInfrastructure: 'بنية CDN التحتية',
    pullFromGitHub: 'السحب من GitHub',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'فحص Spectral',
    jsonSchemaHosting: 'استضافة JSON Schema',
    askAi: 'اسأل الذكاء الاصطناعي',
    mcpServers: 'خوادم MCP',
    unableToExportDocument: 'تعذر تصدير المستند النشط',
    unknownError: 'حدث خطأ غير معروف',
  },
  gettingStarted: {
    swaggerEditor: 'Swagger Editor',
    description:
      'مرحبًا بك في Scalar API References + Swagger Editor، أداة مجانية ومفتوحة المصدر تأخذ ملف Swagger/OAS الخاص بك وتنشئ API References جميلة.',
    showExample: 'إظهار مثال',
    uploadFile: 'تحميل ملف',
    integrations: 'التكاملات',
    theming: 'السمات',
    features: 'الميزات',
    customize: 'التخصيص',
    customizeDescription: 'استخدم الخطوط ولوحات الألوان الخاصة بك، أو استخدم سماتنا!',
    testing: 'الاختبار',
    testingDescription: 'REST API Client مدمج بعمق (مجاني ومفتوح المصدر أيضًا)',
    search: 'البحث',
    searchDescription: 'بحث مدمج بالكامل (باستخدام fuse.js)',
    hosting: 'الاستضافة',
    hostingDescription: 'استضافة مجانية لنطاق فرعي على https://apidocumentation.com',
    openApiSwagger: 'OpenAPI و Swagger',
    openApiSwaggerDescription: 'دعم OpenAPI 3.1 و OpenAPI 3.0 و Swagger 2.0',
    codeSamples: 'أمثلة التعليمات البرمجية',
    codeSamplesDescription: 'أمثلة تعليمات برمجية لعرض API الخاص بك بأشهر اللغات',
  },
  footer: {
    poweredByScalar: 'مدعوم من Scalar',
  },
  authentication: {
    title: 'المصادقة',
    accepts: 'يقبل',
    allOf: 'كل ما يلي:',
    authentication: 'المصادقة',
    optional: 'المصادقة اختيارية',
    oneOf: 'واحد من:',
    required: 'المصادقة مطلوبة',
    requires: 'يتطلب',
    scopes: 'نطاقات OAuth',
  },
} satisfies ApiReferenceTranslations
